var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"wrapper",attrs:{"id":"pdf-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }